export const SUPERADMIN = 1;
export const ORGANIZATION = 2;
export const MANAGER = 3;
export const globalErrorMesg =
  "An unexpected error occurred. Please try again, or contact support@toptipper.co for support if you continue to receive this message.";
export const countries = [{ value: 1, label: "United States" }];
// Sample list of phone numbers
export const phoneNumbers = [{ countryCode: "1", country: "United States" }];
